import { render, staticRenderFns } from "./ShowQuotation.vue?vue&type=template&id=ded48c8e&scoped=true"
import script from "./ShowQuotation.vue?vue&type=script&lang=js"
export * from "./ShowQuotation.vue?vue&type=script&lang=js"
import style0 from "./ShowQuotation.vue?vue&type=style&index=0&id=ded48c8e&prod&lang=css"
import style1 from "./ShowQuotation.vue?vue&type=style&index=1&id=ded48c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded48c8e",
  null
  
)

export default component.exports